import { render } from "./form-user-bank.vue?vue&type=template&id=fdfa09dc"
import script from "./form-user-bank.vue?vue&type=script&lang=js"
export * from "./form-user-bank.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__